import LiquidText from './LiquidText';
import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { LiquidDialog } from './LiquidUI';
import { OrcamentoIcon } from './OrcamentoUI';
import './EquipmentDialogs.css';
import './ProdutoDocumentacaoModal.css';
import './ProdutoDocumentacaoLoteModal.css';

const labels = { fds: 'FDS', ficha_tecnica: 'Ficha técnica' };
const uuid = () => '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
export default function ProdutoDocumentacaoLoteModal({ onClose, onSaved }) {
    const [pedidos, setPedidos] = useState(null);
    const [selecionados, setSelecionados] = useState([]);
    const [resultados, setResultados] = useState({});
    const [erro, setErro] = useState('');
    const [ocupado, setOcupado] = useState(false);
    const [parado, setParado] = useState(false);
    const [iniciado, setIniciado] = useState(false);
    const emCurso = useRef(false);
    const parar = useRef(false);
    useEffect(() => {
        let ativo = true;
        api.get('/produtos-quimicos/pedidos-documentacao/lote').then(r => {
            if (!ativo) return;
            setPedidos(r.data.pedidos);
            setSelecionados(r.data.pedidos.filter(p => p.email_valido && !p.ja_pedido).map(p => p.produto.id));
        }).catch(() => { if (ativo) setErro('Não foi possível preparar os pedidos. Feche e volte a abrir.'); });
        return () => { ativo = false; parar.current = true; };
    }, []);
    const fechar = () => { if (!emCurso.current) onClose(); };
    const mudar = id => setSelecionados(s => s.includes(id) ? s.filter(v => v !== id) : [...s, id]);
    const atualizar = (id, valor) => setResultados(r => ({ ...r, [id]: valor }));
    const enviar = async () => {
        if (emCurso.current || iniciado || !selecionados.length) return;
        emCurso.current = true; parar.current = false;
        setOcupado(true); setIniciado(true); setErro('');
        try {
            for (const p of pedidos.filter(p => selecionados.includes(p.produto.id) && p.email_valido)) {
                if (parar.current) break;
                atualizar(p.produto.id, { estado: 'a_enviar', texto: 'A enviar…' });
                try {
                    const r = await api.post(`/produtos-quimicos/${p.produto.id}/pedido-documentacao`, { chave: uuid(), versao: p.versao }, { timeout: 45000 });
                    atualizar(p.produto.id, { estado: r.data.estado, texto: r.data.estado === 'enviado' ? 'Aceite pelo servidor de email' : 'Pedido registado — consulte o histórico' });
                } catch (e) {
                    const pedido = e.response?.data?.pedido;
                    const incerto = !e.response || e.response.status >= 500;
                    atualizar(p.produto.id, { estado: pedido?.estado || (incerto ? 'incerto' : 'nao_enviado'), texto: e.response?.data?.error || 'Resultado por confirmar. Consulte o histórico antes de repetir.' });
                    if (e.response?.status === 401 || e.response?.status === 403) { parar.current = true; setParado(true); }
                }
            }
        } finally {
            emCurso.current = false; setOcupado(false); onSaved();
        }
    };
    const concluidos = Object.values(resultados).filter(r => r.estado !== 'a_enviar').length;
    const aceites = Object.values(resultados).filter(r => r.estado === 'enviado').length;
    const porRever = concluidos - aceites;
    return <LiquidDialog onClose={fechar} onClick={fechar} style={{ position: 'fixed', inset: 0, zIndex: 1200, background: '#19324966', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <section className="equipment-dialog produto-documentacao-modal produto-documentacao-lote" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
            <div className="equipment-dialog-header">
                <div><h3><OrcamentoIcon name="send" fallback="↗" /> Pedidos de documentação em lote</h3><p>Um email por produto, enviado apenas ao respetivo fabricante. Cada pedido fica no histórico.</p></div>
                <button className="equipment-dialog-close" aria-label="Fechar pedidos em lote" disabled={ocupado} onClick={fechar}><OrcamentoIcon name="close" fallback="✕" /></button>
            </div>
            <div className="equipment-dialog-body">
                {erro && <p role="alert" className="produto-documentacao-message is-error">{erro}</p>}
                {!pedidos && !erro && <p role="status">A preparar os pedidos…</p>}
                {pedidos && <>
                    <div className="pq-bulk-summary">
                        <span><b>{pedidos.length}</b> produtos com documentos em falta</span>
                        <span><b>{pedidos.filter(p => !p.email_valido).length}</b> sem email válido</span>
                        <span><b>{pedidos.filter(p => p.ja_pedido).length}</b> com pedido já registado</span>
                    </div>
                    {!iniciado && <div className="pq-bulk-selection">
                        <button className="btn-secondary" onClick={() => setSelecionados(pedidos.filter(p => p.email_valido && !p.ja_pedido).map(p => p.produto.id))}>Selecionar pedidos novos</button>
                        <button className="btn-secondary" onClick={() => setSelecionados([])}>Limpar seleção</button>
                        <p>Os pedidos já registados ficam desmarcados. Selecione-os apenas se pretender pedir novamente.</p>
                    </div>}
                    {!pedidos.length && <p>Todos os produtos têm FDS e ficha técnica disponíveis.</p>}
                    {pedidos.map(p => {
                        const r = resultados[p.produto.id];
                        return <article className="pq-bulk-item" key={p.produto.id}>
                            <label className="pq-bulk-product"><input type="checkbox" aria-label={`Selecionar ${p.produto.nome}`} checked={selecionados.includes(p.produto.id)} disabled={iniciado || !p.email_valido} onChange={() => mudar(p.produto.id)} /><span><strong>{p.produto.nome}</strong><small>{p.produto.marca} · {p.tipos.map(t => labels[t]).join(' + ')}</small></span></label>
                            <p className="pq-bulk-recipient"><OrcamentoIcon name="mail" fallback="✉" /> {p.destinatario || 'Sem email'}{!p.email_valido && <span> — complete o contacto na ficha do produto</span>}</p>
                            {p.ja_pedido && <p className="produto-documentacao-hint">Último pedido: {new Date(p.ultimo_pedido.criado_em).toLocaleString('pt-PT')} · {p.ultimo_pedido.estado === 'enviado' ? 'aceite pelo servidor' : 'envio por confirmar — consulte o histórico antes de repetir'}</p>}
                            <details><summary>Ver mensagem</summary><b>{p.assunto}</b><pre>{p.corpo}</pre></details>
                            {r && <p role="status" className={`pq-bulk-result ${r.estado === 'enviado' ? 'is-success' : 'is-review'}`}><LiquidText>{r.texto}</LiquidText></p>}
                            {iniciado && !ocupado && selecionados.includes(p.produto.id) && !r && <p>Não enviado — lote interrompido.</p>}
                        </article>;
                    })}
                </>}
            </div>
            <div className="equipment-dialog-footer produto-documentacao-actions">
                <p className="pq-bulk-progress" role="status">{iniciado ? `${concluidos}/${selecionados.length} processados · ${aceites} aceites · ${porRever} por rever` : `${selecionados.length} pedidos selecionados`}</p>
                {ocupado ? <button className="btn-secondary" disabled={parado} onClick={() => { parar.current = true; setParado(true); }}>{parado ? 'A terminar o pedido atual…' : 'Parar após este pedido'}</button>
                    : iniciado ? <button className="btn-secondary" onClick={fechar}>Concluir</button>
                        : <button data-liquid-primary="true" className="pedido-enviar" disabled={!pedidos || !selecionados.length} onClick={enviar}><OrcamentoIcon name="send" fallback="↗" /> Enviar {selecionados.length} pedidos</button>}
            </div>
        </section>
    </LiquidDialog>;
}
